import axios from "axios";
const backend_url = process.env.VUE_APP_HOSTNAME
const domain_url = process.env.VUE_APP_DOMAIN
const ENV = process.env.NODE_ENV
const MODE = process.env.VUE_APP_MODE
const VERSION = (process.env.VUE_APP_VERSION) ? process.env.VUE_APP_VERSION : '1'

const BLOG_PUBLIC_API_BASE = '/blog/api'

function normalizeBaseUrl(value = '') {
    return value.replace(/\/+$/, '')
}

function buildPublicApiUrl(path = '') {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`

    if (!backend_url) {
        return `${BLOG_PUBLIC_API_BASE}${normalizedPath}`
    }

    return `${normalizeBaseUrl(backend_url)}${BLOG_PUBLIC_API_BASE}${normalizedPath}`
}

function normalizeQuery(params = {}) {
    return Object.entries(params).reduce((result, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            result[key] = value
        }

        return result
    }, {})
}

function createValidationError(message, details = []) {
    return {
        result: false,
        error: 'validation_error',
        message,
        details,
    }
}

function createRequestError(error) {
    const responseData = error?.response?.data

    if (responseData && typeof responseData === 'object') {
        return responseData
    }

    return {
        result: false,
        error: 'request_failed',
        message: error?.message || 'Request failed',
        details: [],
    }
}

export default class Connect {
    constructor() {

    }

    get env() {
        return ENV
    }
    
    get mode() {
        return MODE
    }

    get version() {
        return VERSION
    }

    get backend_url() {
        return backend_url
    }

    get domain_url() {
        return domain_url
    }

    // Единая точка для публичных запросов к blog API.
    async request(path, params = {}) {
        try {
            const response = await axios.get(buildPublicApiUrl(path), {
                params: normalizeQuery(params),
            })

            return response.data
        } catch (error) {
            console.error(`Connect request failed: GET ${path}`, error)
            return createRequestError(error)
        }
    }

    // Проверка доступности публичного blog API.
    async GetHealth() {
        return this.request('/health')
    }

    // Список опубликованных статей с фильтрацией, поиском и пагинацией.
    async GetArticles(params = {}) {
        return this.request('/articles', params)
    }

    // Детальная статья по code; legacy endpoint name может оставаться slug до обновления backend.
    async GetArticleByCode(code) {
        if (!code) {
            return createValidationError('code is required', ['code is required'])
        }

        return this.request(`/articles/${encodeURIComponent(code)}`)
    }

    // Backward-compatible alias для старого нейминга.
    async GetArticleBySlug(slug) {
        return this.GetArticleByCode(slug)
    }

    // Похожие статьи для карточки рекомендаций по code.
    async GetRelatedArticlesByCode(code, limit) {
        if (!code) {
            return createValidationError('code is required', ['code is required'])
        }

        return this.request(`/articles/related/${encodeURIComponent(code)}`, { limit })
    }

    // Backward-compatible alias для старого нейминга.
    async GetRelatedArticles(slug, limit) {
        return this.GetRelatedArticlesByCode(slug, limit)
    }

    // Статистика тегов для фильтров.
    async GetArticleTags() {
        return this.request('/articles/tags')
    }
}

